import 'bootstrap'
import helper from './helper'

export default () => {
  // TO DO
  const offcanvasRight = $('#offcanvasSearch, #offcanvasFilters')
  offcanvasRight.bind('hidden.bs.offcanvas show.bs.offcanvas', function (e) {
    if (e.type === 'show') {
      $('body').addClass('offcanvasRight')
    } else {
      $('body').removeClass('offcanvasRight')
    }
  })

  const offcanvasLeft = $('#offcanvasMenu')
  offcanvasLeft.bind('hidden.bs.offcanvas show.bs.offcanvas', function (e) {
    if (e.type === 'show') {
      $('body').addClass('offcanvasLeft')
    } else {
      $('body').removeClass('offcanvasLeft')
    }
  })

  /**
   * Mega menu toggle
   */
  $('.stb-header .stb-header__main-menu-dropdown>.menu-item>a').click((e) => {
    const _seft = $(e.target)
    $('.sub-mega-menu').removeClass('d-block')
    _seft.parents('.menu-item').find('.sub-mega-menu').toggleClass('d-block')
    $('body').click(() => { $('.sub-mega-menu').removeClass('d-block') })
    $('.stb-header__main-menu').click((e) => { e.stopPropagation() })
  })

  /**
   * Sidebar menu toggle
   */
  $('#offcanvasMenu .navigate-back').click(() => {
    $('.sidebar-menu__primary .open').removeClass('open')
    $('#offcanvasMenu .btn-close').removeClass('d-none').addClass('d-flex')
    $('#offcanvasMenu .navigate-back').removeClass('d-flex').addClass('d-none')
  })
  $('.sidebar-menu__primary .menu-item-arrow.arrow-icon').click((e) => {
    e.preventDefault()
    const _seft = $(e.target)
    $('#offcanvasMenu .btn-close').removeClass('d-flex').addClass('d-none')
    $('#offcanvasMenu .navigate-back').removeClass('d-none').addClass('d-flex')
    _seft.parents('.menu-item').children('.sub-menu').addClass('open')
  })

  /**
   * Toggle menu filter sidebar
   */
  $('#offcanvasFilters .widget-title').click((e) => {
    const _seft = $(e.target)
    _seft.parents('.widget').toggleClass('open')
  })
  $('#offcanvasFilters .chosen, #offcanvasFilters .current-cat').parents('.widget').addClass('open')

  /**
   * Tabs single product
  */
  $('.wc-tabs .tab-title').click((e) => {
    const _seft = $(e.currentTarget)
    const tabContent = $(`#${_seft.attr('aria-controls')}`)

    _seft.toggleClass('open')
    tabContent.toggleClass('open')
  })

  /**
   * Search ajax product_search
   * */
  const productSearchCache = {}
  let globalTimeout = null
  $('.stb-sidebar__search-form-input').keyup( (e) => {
    const _self = $(e.currentTarget)
    const searchResult = $('.stb-search-result')
    const searchKey = _self.val()
    let objKey = searchKey
    const productSkeleton = `
    <div class="stb-search-item loading">
        <div class="stb-search-item__img">
          <figure class="stb-search-item__thumbnail"></figure>
        </div>
        <div class="stb-search-item__content">
          <span class="stb-search-item__content-title"></span>
          <span class="stb-search-item__content-info"></span>
        </div>
      </div>`
  
    if (searchKey.length > 1) {
      searchResult.html(productSkeleton)
      $('.stb-search__caption').addClass('d-none')
      $('.stb-search__link').addClass('d-none')
      $('.stb-search__link .stb-search__link-key').html(` "${searchKey}"`)
      const searchURL = $('.stb-search__link a').data('search_url')
      $('.stb-search__link a').attr('href', `${searchURL}?s=${searchKey}`)

      if (objKey in productSearchCache) {
        $('.stb-search__caption').removeClass('d-none')
        $('.stb-search__link').removeClass('d-none')
        searchResult.html(productSearchCache[objKey])
      } else {
        if (globalTimeout != null) {
          clearTimeout(globalTimeout)
        }
        globalTimeout = setTimeout(() => {
          globalTimeout = null
      
          helper.productSearch(searchKey, (html) => {
            if (html) {
              productSearchCache[objKey] = html
              searchResult.html(html)
              $('.stb-search__caption').removeClass('d-none')
              $('.stb-search__link').removeClass('d-none')
            } else {
              searchResult.html('')
              $('.stb-search__caption').addClass('d-none')
              $('.stb-search__link').removeClass('d-none')
            }
          })
        }, 200)
      }
    } else {
      searchResult.html('')
      $('.stb-search__caption').addClass('d-none')
      $('.stb-search__link').addClass('d-none')
    }
  })

  /**
   * Show and hide Back to top
   * */
  if (document.documentElement.scrollTop >= 400) {
    $('.stb-btn___back-to-top').addClass('show')
  }

  window.onscroll = () => {
    const distanceScrolled = document.documentElement.scrollTop
    if(distanceScrolled >= 400){
      $('.stb-btn___back-to-top').addClass('show')
    }
    if(distanceScrolled < 400){
      $('.stb-btn___back-to-top').removeClass('show')
    }		
	}

  //product filter
  // const currentUrl = new URL(window.location.href)
  // const urlSearch = new URL(`${currentUrl.origin}/${omoeo.lang}/collections`)
  // $('.product-categories li a').click(function (){
  //   $(this).parent().addClass('chosen')
  //   urlSearch.searchParams.append('cate', $(this).text())
  //   console.log(urlSearch.href)
  //   return false
  // })

  $(document).ready(function (){
    $('.woof_container_inner_brands .woof_list_checkbox li').has('div.disabled').hide()
  })
}
